<template>
  <div id="app" :class="{'is-iphonex': isIphonex}">
    <router-view/>
    
    <span id="jiHuoBaiTiao" :psa="$root.$options.windowCONFIG.psaPrefix+'jiHuoBaiTiao'" :clstag="$root.$options.windowCONFIG.clstagPrefix+'jiHuoBaiTiao'"></span>
  </div>
</template>

<script>
  function isIphonex() {
    let u = navigator.userAgent;
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    let flag = false;
    if (isIOS) {
      if (window.screen.height == 812 && window.screen.width == 375) {
        flag = true;
        //是iphoneX
      } else if (window.screen.height == 896 && window.screen.width == 414) {
        //是iphone xs max
        flag = true;
      } else {
        flag = false;
        //不是iphoneX
      }
    }
    return flag;
  }
  
  export default {
    data() {
      return {
        isIphonex: isIphonex()
      };
    }
  };
</script>